import { render, staticRenderFns } from "./OtherSymptoms.vue?vue&type=template&id=3f5a9159"
import script from "./OtherSymptoms.vue?vue&type=script&lang=js"
export * from "./OtherSymptoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports